// Lifecycle of an AI-connector action that waits for the user's approval (RYDE-8447). Mirrors the backend enum:
// Pending until the user decides on the approval page; an approved action runs at most once, to Done or Failed.
export enum McpConnectorActionStatusEnum {
  Pending = "Pending",
  Approved = "Approved",
  Denied = "Denied",
  Expired = "Expired",
  Running = "Running",
  Done = "Done",
  Failed = "Failed",
}
